module.exports = __webpack_public_path__ + "static/img/222.3817137.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/222.jpg
// module id = t+M1
// module chunks = 0